/* eslint-disable no-unused-vars */
import React from 'react';

import { ThreeColumnLayout } from 'sharedComponents/ThreeColumnLayout';

const LayoutComponent = () => {
    return (
        <>
            <ThreeColumnLayout
                rightPanelDefaultWidth={25}
                leftPanelDefaulWidth={25}
                leftPanelHeader='Menu'
                rightPanelHeader='Right Panel'
            >
                {/* Left Panel Content */}
                <div style={{ height: '100%' }}>Main Content Here111</div>
                {/* Center Content */}
                <div style={{ background: 'lightgreen', height: '100%' }}>Source Viewer</div>
                {/* Right Panel Content */}
                {/* <div><p>Right Panel Content Test1</p></div> */}
            </ThreeColumnLayout>
        </>
    );
};

export default LayoutComponent;
